//Local
// export const API_URL = 'http://localhost:8080/clms/api/';

//Prod
export const API_URL = '/clms/api/';

// export const AUTH_ENABLED = false;
// export const IMAGE_URL = "https://competitorsclaimstorage.blob.core.windows.net/";


export const TOKEN = localStorage.getItem("token");
